import { process } from "@progress/kendo-data-query";

const UNGROUPED = "(Ungrouped)";
const SYSTEM_INFO = "System Information";

/**
 * Sorts groups alphabetically, with "System Information" second-to-last and "(Ungrouped)" always last.
 * @param {string[]} groups - Array of group names
 * @returns {string[]} Sorted array
 */
function getGroupSortRank(name) {
    const n = (name || "").trim();
    if (n === UNGROUPED) return 2;
    if (n === SYSTEM_INFO) return 1;
    return 0;
}

export { UNGROUPED, SYSTEM_INFO };

/**
 * Returns grouped and sorted data for Kendo Grid with group expand/collapse.
 * @param {object[]} data - Flat array of items with optional group field
 * @param {string} groupField - Field name for grouping (default: "group")
 * @returns {object} Result from process() with sorted groups
 */
export function getGroupedData(data, groupField = "group") {
    if (!data || !data.length) return { data: [] };
    const normalizedData = data.map((item) => ({
        ...item,
        [groupField]: (item[groupField] && String(item[groupField]).trim()) ? item[groupField] : UNGROUPED,
    }));
    const result = process(normalizedData, { group: [{ field: groupField }] });
    if (result.data && result.data.length > 1) {
        const sortedData = [...result.data].sort((a, b) => {
            const aVal = a.value || "";
            const bVal = b.value || "";
            const rankA = getGroupSortRank(aVal);
            const rankB = getGroupSortRank(bVal);
            if (rankA !== rankB) return rankA - rankB;
            return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: "base" });
        });
        sortedData.forEach(group => {
            if (group.expanded === undefined) {
                group.expanded = true;
            }
        });
        return { ...result, data: sortedData };
    }
    return result;
}

export function sortAttributeGroups(groups) {
    if (!groups || !Array.isArray(groups)) return [];
    return [...groups].sort((a, b) => {
        const rankA = getGroupSortRank(a);
        const rankB = getGroupSortRank(b);
        if (rankA !== rankB) return rankA - rankB;
        return String(a || "").localeCompare(String(b || ""), undefined, { sensitivity: "base" });
    });
}
